import React, { useState, useEffect, useContext } from "react";
import { getAllUsers, getUser } from "../../Services/UserService";
import * as Components from "./Component";
import { TOAST_MESSAGES } from "../Bills/constants";
import { useDashboard, UserContext } from "../../Context";
import toast from "react-hot-toast";
import { getMonthStartEndDates, getFormattedDate } from "../../Utils";
import { GET_ALL_PAGINATION } from "../../Constants/Strings";
import { extractErrorMessage } from "../../Utils/extractErrorMessage";

const DashboardCharts = () => {
  const [usersData, setUsersData] = useState([]);
  const { filters, updateFilter } = useDashboard();
  const { user } = useContext(UserContext);

  const fetchUsers = async () => {
    try {
      const [currentUserRes, allUsersRes] = await Promise.all([
        getUser(),
        getAllUsers(GET_ALL_PAGINATION),
      ]);

      if (currentUserRes.status === 200 && allUsersRes.status === 200) {
        const currentUser = currentUserRes.data;
        const allUsers = allUsersRes.data?.results || [];
        const filteredUsers = allUsers.filter((u) => u.id !== currentUser.id);
        setUsersData([currentUser, ...filteredUsers]);
        if (!filters.user_id) {
          const { firstDay, lastDay } = getMonthStartEndDates();
          updateFilter({
            user_id: currentUser.id,
            start_date: getFormattedDate(firstDay),
            end_date: getFormattedDate(lastDay),
          });
        }
      }
    } catch (error) {
      const msg = extractErrorMessage(error) || TOAST_MESSAGES.FAILED_TO_FETCH;
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  return (
    <div className="w-full py-8">
      <div className="flex flex-col gap-4 mb-6 md:flex-row md:items-center md:justify-between">
        <div className="text-primary text-2xl md:text-3xl font-extrabold text-center md:text-left">
          Dashboard
        </div>

        <div className="flex flex-col gap-4 w-full md:flex-row md:items-end md:justify-end">
          {(user.role === "ADMIN" || user.role === "PROJECT_INCHARGE" || user.role === "INCHARGE" || user.role === "DIRECTOR_MANAGEMENT") && <div className="w-full md:w-[200px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              User
            </label>
            <select
              value={filters.user_id || ""}
              onChange={(e) => updateFilter({ user_id: e.target.value })}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
            >
              {usersData.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.first_name} {user.last_name}
                </option>
              ))}
            </select>

          </div>}
          <div className="flex justify-between gap-2">
            <div className="w-full md:w-[200px] flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                Start Date
              </label>
              <input
                type="date"
                className="w-full border-1 rounded-lg border-[1px] border-gray-300 overflow-hidden bg-white text-sm shadow-sm focus:outline-none"
                onChange={(e) => updateFilter({ start_date: e.target.value })}
                value={filters?.start_date || ""}
              />
            </div>
            <div className="w-full md:w-[200px] flex flex-col gap-1">
              <label className="text-sm font-medium text-gray-700">
                End Date
              </label>
              <input
                type="date"
                className="w-full border-1 rounded-lg border-[1px] border-gray-300 overflow-hidden bg-white text-sm shadow-sm focus:outline-none"
                onChange={(e) => updateFilter({ end_date: e.target.value })}
                value={filters?.end_date || ""}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Components.TaskSummary />
        <Components.BillSummaryCard />
        <Components.AttendanceSummary />
      </div>
    </div>
  );
};

export default DashboardCharts;
